// Filename: collections/activitys
define('collections/calendar/text-session/activity-types',[
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    'services/api',
    // Pull in the Model module from above
    'models/calendar/text-session/activity-type'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // src
    API,
    // model
    MActivityType
) {

    var CActivityTypes = Backbone.Collection.extend({
        model: MActivityType,
        url: API.url("activities/"),
        comparator: function(a, b) {
            return a.get('name').localeCompare(b.get('name'));
        }
    });

    return CActivityTypes;
});

